export const KeyCodes = { $o: 32, Fo: 9, Co: 13, Oh: 27 };
